export const inputCls = "w-full bg-black/60 border border-white/15 px-3 py-2 font-mono text-xs text-zinc-100 rounded-none focus:outline-none focus:border-nc-orange placeholder:text-zinc-600";
export const labelCls = "font-mono text-[9px] tracking-[0.25em] text-zinc-500 uppercase block mb-1";
export const btn = "font-mono text-[9px] tracking-[0.15em] uppercase px-3 py-2 transition-colors flex items-center gap-1.5 disabled:opacity-40";
export const btnPrimary = `${btn} bg-nc-orange hover:bg-nc-orange/80 text-white`;
export const btnBlue = `${btn} bg-nc-blue hover:bg-nc-blue/80 text-white`;
export const btnGhost = `${btn} border border-white/15 text-zinc-300 hover:border-white/40`;
export const btnDanger = `${btn} border border-red-500/40 text-red-400 hover:bg-red-500/10`;

export const STATUS_COLOR = { waitlisted: "text-zinc-400 border-white/15", approved: "text-nc-blue border-nc-blue/40", active: "text-nc-green border-nc-green/40", revoked: "text-red-400 border-red-500/40", declined: "text-zinc-500 border-white/10" };
export const LABEL_COLOR = { healthy: "#22c55e", "gpu-bound": "#FF6B1A", "cpu-game-thread": "#eab308", "cpu-render-thread": "#f59e0b", vram: "#ef4444", ram: "#dc2626", hitching: "#a855f7", network: "#2E6BFF", "server-tick": "#06b6d4", "balanced-slow": "#f97316", collecting: "#52525b", unclassified: "#71717a" };

export function Stat({ label, value, hint, testId }) {
  return (
    <div data-testid={testId} className="border border-white/10 bg-black/40 p-4">
      <p className="font-sans font-extrabold text-2xl text-white leading-tight">{value}</p>
      <p className="font-mono text-[9px] tracking-[0.25em] uppercase text-zinc-500 mt-1">{label}</p>
      {hint && <p className="font-mono text-[10px] text-zinc-600 mt-1">{hint}</p>}
    </div>
  );
}

export function Bar({ label, value, max, color = "#FF6B1A", suffix = "", testId }) {
  const pct = max ? Math.max(2, Math.round((value / max) * 100)) : 0;
  return (
    <div data-testid={testId} className="flex items-center gap-3">
      <p className="font-mono text-[10px] text-zinc-300 w-40 truncate shrink-0">{label}</p>
      <div className="flex-1 h-2 bg-white/5"><div className="h-2 transition-[width] duration-500" style={{ width: `${pct}%`, backgroundColor: color }} /></div>
      <p className="font-mono text-[10px] text-zinc-400 w-20 text-right shrink-0">{value}{suffix}</p>
    </div>
  );
}
